import React from 'react';

import { Button, Space } from '@sravni/react-design-system';
import { Link, Text } from '@sravni/react-design-system/lib/Typography';
import { useIsMobile, useStyles } from '@sravni/react-utils';
import { getOrganizationHelpers } from '@sravni/ugc/lib/organizations/helpers';
import { OrganizationTypes, TOrganizationTypes } from '@sravni/ugc/lib/organizations/types';

import { ITEM, ITEM_MFO } from '../../constants/routes';
import { createLinkProps } from '../../utils/routing';

import styles from './review-moderation.module.scss';
import { STEPS } from './steps';

type TReviewModerationProps = {
  organizationType: TOrganizationTypes;
  className?: string;
  organizationAlias: string;
  reviewId: number;
};

export const ReviewModeration: React.FC<TReviewModerationProps> = ({
  organizationType,
  className,
  organizationAlias,
  reviewId,
}) => {
  const cx = useStyles(styles);
  const isMobile = useIsMobile();
  const orgHelper = getOrganizationHelpers(organizationType);

  const isMfo = organizationType === OrganizationTypes.Mfo;
  const itemRoute = isMfo ? ITEM_MFO : ITEM;

  const reviewLink = createLinkProps('/review', itemRoute, {
    type: orgHelper.listTypeUrl,
    organization: organizationAlias,
    id: reviewId,
  });

  return (
    <div className={cx('wrapper', className)}>
      <Text size={16} strong>
        Как проходит модерация отзыва
      </Text>

      <Space
        className={cx('steps', isMobile ? 'h-mt-16' : 'h-mt-24')}
        direction={isMobile ? 'vertical' : 'horizontal'}
        size={8}
      >
        {STEPS.map(({ heading, text }, index) => (
          <Space
            key={heading}
            className={cx('step')}
            size={16}
            direction={isMobile ? 'horizontal' : 'vertical'}
            align={isMobile ? 'center' : null}
          >
            <Text size={14} className={'h-color-D60 h-ml-4'} strong>
              {index + 1}
            </Text>
            <div>
              <Text size={14} strong className={'h-color-D100'}>
                {heading}
              </Text>
              <Text size={14} className={'h-mt-4 h-color-D60'}>
                {text}
              </Text>
            </div>
          </Space>
        ))}
      </Space>

      <Space size={isMobile ? 16 : 8} direction={'horizontal'} className={cx('buttons')}>
        <Link href={reviewLink.as} className={cx('button')}>
          <Button size={isMobile ? 44 : 60} variant="secondary" block>
            К отзыву
          </Button>
        </Link>
        <Link href={'https://sravni.id/user/profile/activity/'} className={cx('button')}>
          <Button size={isMobile ? 44 : 60} variant="primary" block>
            В личный кабинет
          </Button>
        </Link>
      </Space>
    </div>
  );
};
